import Vue from "vue";
import { Lang } from "../../api";

export default {
  // We're using the beforeMount because the language labels is just personalized displaying of data.
  // Business logic's should never depend on these language labels so we load them in the last step before mounting the vue component.
  beforeMount() {
    Lang.bulk(Lang.NL, this.messageKeys)
      .then(messages => Vue.set(this, "messages", messages))
      .catch(error =>
        console.error("Error retrieving language labels: " + error)
      );
  },
  data() {
    return {
      messageKeys: [],
      messages: {}
    };
  }
};
